import { useState, useEffect } from   'react';
import { useNavigate, useParams} from 'react-router-dom';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { useForm } from 'react-hook-form';
import { Tooltip } from 'react-tooltip';   
import { Row, Col, Form, Button } from 'react-bootstrap';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';
import { useAuth } from '../../Auth/AuthContext';
import { de } from 'date-fns/locale';

export default function FormularioDFI() {
    const { token, user } = useAuth();
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({})
    const { iddx } = useParams();
    const [Cargando, setCargando] = useState(false)
    const [categorias, setCategorias] = useState([])
    const [factores, setFactores] = useState([]);
    const [factoresCategoria, setFactoresCategoria] = useState([]); 
    const {register, handleSubmit, reset, setValue, getValues, watch, formState: { errors }} = useForm();
    const Mensaje = (title, text, icon) => {
        setSwalProps({
            show: true,
            title,
            text,
            icon, // 'success' or 'error'
        });
    };
    const cambiarFactores = (idCategoria) => {
        const factoresFiltrados = factores.filter(factor => factor.id_categoria.toString() === idCategoria);
        setFactoresCategoria(factoresFiltrados);
    }
    function irACaracterizaciondfi() {
        navigate('/dx/caracterizaciondfi');
    }
    
    const onSubmit = async (data) => {
            setCargando(true);
            const url = '/diagnostico/guardarcaracterizaciondfi';
            try {
                const response = await apiService.post(url, data, token);
                if(response.status === 200){
                    Mensaje('Guardar Identificacion', 'Guardado correctamente', 'success');
                }
            } catch (error) {
                if(error.status === 422){
                    Mensaje('Guardar Identificacion', JSON.stringify(error.response.data.errors), 'error');
                }else if(error.status === 409){
                    Mensaje('Guardar Identificacion', JSON.stringify(error.response.data), 'error');
                }else{
                    Mensaje('Guardar Identificacion', `Error al guardar ${error.message}`, 'error');
                }
                console.error('Error fetching data:', error);
            } finally {
              setCargando(false);
            }
          };
    useEffect(() => {
        const fetchData = async () => {
            setCargando(true);
            const url = '/diagnostico/crearformulariodfi';
            const obj = {
                iddx: iddx,
            };
            try {
                const response = await apiService.post(url, obj, token);
                if(response.status === 200){
                    if (response.data.categorias) {
                        setCategorias(response.data.categorias);
                    }else{
                        setCategorias([]);
                    }
                    if (response.data.factores) {
                        setFactores(response.data.factores);
                        setFactoresCategoria(response.data.factores.filter(
                            factor => factor.id_categoria.toString() === response.data.diagnostico.res_6_1_3_categoria?.toString() || ''
                        ));
                    }else{
                        setFactores([]);
                    }
                    if (response.data.diagnostico) {
                        response.data.diagnostico.dx_fecha = new Date(response.data.diagnostico.dx_fecha).toLocaleDateString('en-CA') || '';
                        response.data.res_6_1_3_categoria = response.data.diagnostico.res_6_1_3_categoria?.toString() || '';
                        response.data.res_6_1_2_factor_determinante = response.data.diagnostico.res_6_1_2_factor_determinante?.toString() || '';
                        
                    
                        reset((prevValues) => ({
                            ...prevValues,
                            ...response.data.diagnostico,
                            usrId: user,
                        }));
                    }
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        };
        fetchData();
    }, [iddx, token, reset, user]);
    return (
        
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Caracterizacion DFI - DX"
                idCabezaFamilia="1"
                url="/dx/caracterizaciondfi"
                nombreurl="Caracterizacion DFI"
                nombreform="Caracterizacion DFI - DX"
            />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div id="formDiagnostico" className="card">
                    <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className='card-header'>
                                        <h4>1. CARACTERIZACION DESPLAZAMIENTO FORZADO INTRAURBANO</h4>
                                    </div>
                                    <div className='card-body'>
                                        <Row>
                                        <Col>
                                            <b>ID:</b> {getValues('iddx')}{" "}
                                            <b>FECHA:</b> {getValues('dx_fecha')},{" "}
                                            <b>NOMBRES:</b> {getValues('nombre_completo')},{" "}
                                        </Col>
                                        </Row>
                                        <Row>
                                        <Col>
                                            <b>DOCUMENTO:</b> {getValues('id_1_2_2_n_documento')},{" "}
                                            <b>DEPARTAMENTO:</b> {getValues('departamento')},{" "}
                                            <b>MUNICIPIO:</b> {getValues('municipio')},{" "}
                                            <b>SUBREGION:</b> {getValues('subregion')},{" "}
                                            <b>LUGAR EXACTO:</b> {getValues('vict_4_4_4_lugar_exacto_del_municipio')},{" "}
                                        </Col>
                                        </Row>
                                        <Row>
                                        <Col>
                                            <b>ENTORNO:</b> {getValues('vict_4_4_5_nombre_tipo_entorno')},{" "}
                                            <b>TIPO MOVILIDAD:</b> {getValues('vict_4_4_6_tipo_movilidad')},{" "}
                                            <b>COMUNA:</b> {getValues('vict_4_4_7_hecho_intraurbano_comuna_o_corregimiento')},{" "}
                                            <b>BARRIO:</b> {getValues('vict_4_4_8_hecho_intraurbano_barrio')},{" "}
                                            <b>SECTOR INTRAURBANO:</b> {getValues('vict_4_4_9_hecho_intraurbano_sector_o_asentamiento')},{" "}
                                            <b>DIRECCION:</b> {getValues('vict_4_4_10_hecho_intraurbano_direccion')},{" "}
                                            <b>FECHA HECHO:</b> {getValues('vict_4_5_fecha_hecho')}
                                        </Col>
                                        </Row>
                                        <Row>
                                        <Col>
                                            <b>RESPONSABLE:</b> {getValues('dx_7_1_nombre_responsable_atencion')},{" "}
                                        </Col>
                                        </Row>
                                        <Row>
                                        <Col>
                                            <b>OBSERVACIONES:</b>
                                        </Col>
                                        </Row>
                                        <Row>
                                        <Col>
                                            {getValues('vict_4_7_observaciones')}
                                        </Col>
                                        </Row>
                                        <Row>
                                        <Col md={4}>
                                            <b>CATEGORIA:</b>
                                            <Form.Select
                                            size="sm"
                                            className="form-control"
                                            {...register("res_6_1_3_categoria", { required: "Este campo es obligatorio" })}
                                            onChange={e => {
                                                setValue('res_6_1_3_categoria', e.target.value);
                                                cambiarFactores(e.target.value)
                                                if(e.target.value === '') {
                                                    setValue('res_6_1_2__factor_determinante', '');
                                                    setFactoresCategoria([]);
                                                }
                                            }}
                                            >
                                            <option value="">Seleccione una categoria</option>
                                            {categorias.map(opt => (
                                                <option key={opt.id} value={opt.id}>{opt.categoria}</option>
                                            ))}
                                            {errors.res_6_1_3_categoria && (
                                                <span className="text-danger">{errors.res_6_1_3__categoria.message}</span>
                                            )}
                                            </Form.Select>
                                        </Col>
                                        <Col md={4}>
                                            <b>HECHO DETERMINANTE:</b>
                                            <Form.Select
                                            size="sm"
                                            className="form-control"
                                            {...register("res_6_1_2_factor_determinante", { required: "Este campo es obligatorio" })}
                                            onChange={e => {setValue('res_6_1_2_factor_determinante', e.target.value)}}
                                            >
                                            <option value="">Seleccione una categoria</option>
                                            {factoresCategoria.map(opt => (
                                                <option key={opt.id} value={opt.id}>{opt.factor_incidencia}</option>
                                            ))}
                                            </Form.Select>
                                        </Col>
                                        <Col md={4}>
                                            <b>OTRO:</b>
                                            <Form.Control
                                            type="text"
                                            className="input"
                                            placeholder="Otro"
                                            {...register("res_6_1_1_factores_incidencia")}
                                            onChange={e => { setValue('res_6_1_1_factores_incidencia', e.target.value)}}
                                            />
                                        </Col>
                                        </Row>
                                        <br />
                                        <Row className="justify-content-end">
                                        <Col md={3}>
                                            <Button variant="primary" type="submit">
                                            Guardar
                                            </Button>
                                            <Button variant="secondary" type="button" className="ms-2" onClick={irACaracterizaciondfi}>
                                                Volver
                                            </Button>
                                        </Col>
                                        </Row>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </form>
                </div>     
                <SweetAlert2
                    {...swalProps}
                    didClose={() => setSwalProps({})}
                    onConfirm={() => {
                        if (swalProps.icon === 'success') {
                            setSwalProps({});
                            irACaracterizaciondfi();
                        } else {
                            setSwalProps({});
                        }
                    }}
                />
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
            {/* /.content */}
        </div>
        
    )
  }